export const LAST_DEPARTMENT_ID = 'last.department'
